import { atom } from 'recoil';
import { CIFType } from './POIState';

export interface Metric {
    key: string;
    ismetric?: boolean;
    title: string;
    count?: number;
    icon?: string;
}
export interface User {
    email_id: string;
    user_id: string;
    name: string;
    company: number;
    company_name: string;
    designation: string;
    country: string;
    company_type: number;
    company_type_name: string;
    user_group: string;
    phone_number: string;
    role: string;
    status: string;
    last_login: string;
    profile_picture?: string;
    initial?: string;
    userHSL?: any;
    sublevel: string;
    default_config: {
        type: CIFType | string;
        isselected: boolean;
        title: string;
        description: string;
        options: Metric[];
        hasmbp: boolean;
    }[]
}
export const usersState = atom({
    key: 'users',
    default: [] as User[],
});

export const loggedUserState = atom({
    key: 'loggedUser',
    default: {} as User
});

export const userCurrencyState = atom({
    key: 'userCurrency',
    default: localStorage.getItem('currency') || ''
});